import { Stack } from '@mui/material';
import { FC, useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useLoaderData } from 'react-router-dom';
import { Content } from '../../../../../shared/components/content/content.component';
import { ArticlePostTabDataRes } from '../../../services/article.service';
import { ITabState } from '../../../states/tabState.model';
import { PostForm } from './components/postForm.component';
import { IPostTabState, postTabState } from './post.state';

export const PostTab: FC = () => {
  const { defaultValues } = useLoaderData() as IPostTab;
  const [isArticleIdExist, setIsArticleIdExist] = useState<boolean>(Boolean(defaultValues?.id));
  const { t } = useTranslation();
  const formMetods = useForm<ArticlePostTabDataRes>({
    mode: 'onChange',
    defaultValues,
  });
  const { watch, reset, resetField } = formMetods;

  useEffect(() => {
    const formStateSub = watch((data: Record<string, any>, reason) => {
      if (reason.type === 'change' && reason.name) {
        const fieldName = reason.name;
        postTabState.pub.recordData({
          [fieldName]: data[fieldName],
          id: data.id,
        });
      }
    });
    const unsubarticleIdNotExist = postTabState.sub.articleIdNotExist().subscribe(() => {
      setIsArticleIdExist(false);
      reset({});
    });
    const unsubPostState = postTabState.sub
      .state()
      .subscribe(({ action, defaultValues, dataToSave }: IState) => {
        setIsArticleIdExist(true);
        if (action === 'list.selectedArticle') {
          reset(defaultValues);
        } else {
          const name = Object.keys(dataToSave)[0] as keyof typeof dataToSave;
          resetField(name, {
            defaultValue: dataToSave[name],
            keepDirty: false,
          });
        }
      });

    return () => {
      formStateSub.unsubscribe();
      unsubPostState.unsubscribe();
      unsubarticleIdNotExist.unsubscribe();
    };
  }, []);

  return (
    <>
      {isArticleIdExist ? (
        <Stack
          sx={{
            marginTop: '10px',
          }}
        >
          <PostForm formMethods={formMetods} />
        </Stack>
      ) : (
        <Content
          type='paper'
          paperProps={{
            variant: 'elevation',
            sx: {
              flexGrow: 1,
              display: 'flex',
              flexDirection: 'column',
              overflow: 'auto',
              height: '100%',
            },
          }}
          emptyData={{
            value: true,
            title: t('common.no_data'),
          }}
        />
      )}
    </>
  );
};
interface IState extends IPostTabState {
  defaultValues: ArticlePostTabDataRes;
}
interface IPostTab extends ITabState {
  defaultValues: ArticlePostTabDataRes;
}
